module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/icon-fb22600447a66e6a77e4e3f7c2804fa2.png";